import React, { Component } from 'react'
import i18next from 'i18next'
import moment from 'moment'

import Wopi360RecipientsRow from './Wopi360RecipientsRow'

export default class Wopi360Recipients extends Component {
  render() {
    const {
      wopi360TargetDetails,
      currentLanguage,
      deletedInvitations,
      onCopyLinkClick,
      onDeleteClick,
      sentReminders,
      sendReminderEmail
    } = this.props

    moment.locale(currentLanguage)

    const targetRecipient = wopi360TargetDetails.recipients.find(recipient => recipient.isTarget)
    const remainingRecipients = wopi360TargetDetails.recipients.filter(
      recipient => !recipient.isTarget
    )
    const recipients = [targetRecipient, ...remainingRecipients]

    return (
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th>{i18next.t('invited')}</th>
              <th>{i18next.t('sent_at')}</th>
              <th>{i18next.t('finished_at')}</th>
              <th>{i18next.t('role')}</th>
              <th>{i18next.t('actions')}</th>
              <th>{i18next.t('delete')}</th>
              <th>{i18next.t('send_reminder')}</th>
            </tr>
          </thead>

          <tbody>
            {recipients.map(recipient => (
              <Wopi360RecipientsRow
                key={recipient.uuid}
                recipient={recipient}
                isDeleted={deletedInvitations.contains(recipient.uuid)}
                onCopyLinkClick={onCopyLinkClick}
                onDeleteClick={onDeleteClick}
                onSendReminderClick={sendReminderEmail}
                isReminded={sentReminders.includes(recipient.uuid)}
              />
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360Recipients.js